import { Component } from '@angular/core';
import { TranslateService, LangChangeEvent } from '@ngx-translate/core';
import { Title } from '@angular/platform-browser';


@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {
  constructor(
    private titleService: Title,
    private translate: TranslateService,
  ) {
    // You might set fallback language here too
    // translate.setDefaultLang('en');

    // You might set initial language here too
    // translate.use('fr');

    translate.onLangChange.subscribe((event: LangChangeEvent) => {
      // Change page title when user changes language preference
      translate.get('web.title').subscribe((res: string) => {
        titleService.setTitle(res);
      });
    });
  }
}
